module.exports = __webpack_public_path__ + "img/engagement.0735df3.jpg";